import {
  AlertCircle,
  CheckCircle2,
  CircleAlert,
  CircleSlash,
  Clock,
  Loader,
} from "lucide-react";
import type { DeploymentStepStatus } from "../../../../../../schemas/codegen";

export const StepIcon = ({ status }: { status: DeploymentStepStatus }) => {
  if (status === "error") {
    return <AlertCircle className="w-4 h-4" />;
  }

  if (status === "executing") {
    return <Loader className="w-4 h-4 animate-spin" />;
  }

  if (status === "complete") {
    return <CheckCircle2 className="w-4 h-4 text-success" />;
  }

  if (status === "skipped") {
    return <CircleSlash className="w-4 h-4" />;
  }

  if (status === "cancelled") {
    return <CircleAlert className="w-4 h-4 text-danger" />;
  }

  return <Clock className="w-4 h-4" />;
};
